import { render } from "./MeasurementPage.vue?vue&type=template&id=65d43d5a&scoped=true"
import script from "./MeasurementPage.vue?vue&type=script&lang=js"
export * from "./MeasurementPage.vue?vue&type=script&lang=js"

import "./MeasurementPage.vue?vue&type=style&index=0&id=65d43d5a&scoped=true&lang=css"

import exportComponent from "/home/gbl/SoftwareProjects/MyProjects/UniStuttgart/truscanWebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d43d5a"]])

export default __exports__